export default "__VITE_ASSET__BzNHaD$s__"